export function formatSpanishDate(d: Date | string): string {
  const date = new Date(d);

  const base = new Intl.DateTimeFormat("es-MX", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);

  const lastDe = base.lastIndexOf(" de ");
  return (
    "Creado el " + base.slice(0, lastDe) + " del " + base.slice(lastDe + 4)
  );
}
